import{GenIcon as t}from"../lib/esm/iconBase.js";import"../lib/esm/iconContext.js";function i(i){return t({tag:"svg",attr:{viewBox:"0 0 24 24"},child:[{tag:"path",attr:{d:"M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"}}]})(i)}export{i as GoDotFill};
//# sourceMappingURL=index.esm.js.map
